<template>
    <div class="mx-auto md:grid md:grid-cols-12 md:gap-x-5 md:px-16">
        <div class="space-y-6 sm:px-6 md:px-0 md:col-span-12">
            <Dashboard :totalJobs="totalJobs" :jobsByJobType="jobsByJobType" />
        </div>
    </div>
</template>
<script>
import RecruitersLayout from "@/components/Layouts/RecruitersLayout.vue";

export default {
    layout: RecruitersLayout,
};
</script>
<script setup>
import Dashboard from "@/components/Recruiters/Dashboard.vue";

const props = defineProps({
    totalJobs: Object,
    jobsByJobType: Object,
});

const { totalJobs, jobsByJobType } = props;
</script>
